(function (root, factory) {
  const CfgStairsPrice = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = { CfgStairsPrice };
  } else {
    root.CfgStairsPrice = CfgStairsPrice;
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  const DEFAULT_STAIR_RAMP_VARIANT_ID = 52525129695521;

  /**
   * @param {unknown} n
   * @returns {n is number}
   */
  function isPositiveFinite(n) {
    return typeof n === "number" && Number.isFinite(n) && n > 0;
  }

  /**
   * @param {{ lengthIn?: number, diagonalIn?: number, type?: string } | null | undefined} stair
   * @param {number} rampHeightIn
   * @returns {{ width: number, ramp_height: number, diagonal: number, sides: number, holes: number, notches: number } | null}
   */
  function stairRampInputs(stair, rampHeightIn) {
    if (!stair || typeof stair !== "object") return null;
    const width = Number(stair.lengthIn);
    const diagonal = Number(stair.diagonalIn);
    const rampHeight = Number(rampHeightIn);
    if (!isPositiveFinite(width) || !isPositiveFinite(diagonal) || !isPositiveFinite(rampHeight)) return null;
    return {
      width: width,
      ramp_height: rampHeight,
      diagonal: diagonal,
      sides: stair.type === "double" ? 2 : 1,
      holes: 0,
      notches: 0,
    };
  }

  /**
   * @param {unknown} stairs
   * @param {number} rampHeightIn
   * @param {object | null | undefined} productConfig
   * @param {Function | null | undefined} calculateFn
   * @returns {number}
   */
  function estimateCents(stairs, rampHeightIn, productConfig, calculateFn) {
    if (!productConfig || typeof calculateFn !== "function") return 0;
    const list = Array.isArray(stairs) ? stairs : [];
    let total = 0;
    for (let i = 0; i < list.length; i++) {
      const inputs = stairRampInputs(list[i], rampHeightIn);
      if (!inputs) continue;
      const result = calculateFn(productConfig, inputs);
      const cents = result && Number.isFinite(result.totalPriceCents) ? Number(result.totalPriceCents) : 0;
      total += cents;
    }
    return total;
  }

  /**
   * @param {unknown} index
   * @returns {string}
   */
  function stairCfgKey(index) {
    const n = Math.floor(Number(index));
    const i = Number.isFinite(n) && n >= 1 ? n : 1;
    return "stair_ramp:" + i;
  }

  /**
   * @param {{ lengthIn?: number, heightIn?: number, diagonalIn?: number, steps?: number, type?: string } | null | undefined} stair
   * @param {number} rampHeightIn
   * @returns {Record<string, string> | null}
   */
  function cartProperties(stair, rampHeightIn) {
    const inputs = stairRampInputs(stair, rampHeightIn);
    if (!inputs) return null;
    const steps = Number(stair && stair.steps);
    /** @type {Record<string, string>} */
    const props = {
      width: String(inputs.width),
      ramp_height: String(inputs.ramp_height),
      diagonal: String(inputs.diagonal),
      holes: "0",
      notches: "0",
      sides: String(inputs.sides),
      stair_steps: String(Number.isFinite(steps) && steps >= 1 ? steps : 1),
    };
    const rise = Number(stair && stair.heightIn);
    if (Number.isFinite(rise) && rise > 0) props.panel_height = String(rise);
    return props;
  }

  /**
   * @param {unknown} stairs
   * @param {number} rampHeightIn
   * @param {object | null | undefined} productConfig
   * @param {Function | null | undefined} calculateFn
   * @param {number} [variantId]
   * @returns {Array<{ source: string, variantId: number, qty: number, index: number, cfgKey: string, lengthIn: number, priceCents: number, properties: Record<string, string> }>}
   */
  function pricedLines(stairs, rampHeightIn, productConfig, calculateFn, variantId) {
    if (!productConfig || typeof calculateFn !== "function") return [];
    const vid = Number(variantId) || DEFAULT_STAIR_RAMP_VARIANT_ID;
    const list = Array.isArray(stairs) ? stairs : [];
    /** @type {Array<{ source: string, variantId: number, qty: number, index: number, cfgKey: string, lengthIn: number, priceCents: number, properties: Record<string, string> }>} */
    const lines = [];
    for (let i = 0; i < list.length; i++) {
      const stair = list[i];
      const inputs = stairRampInputs(stair, rampHeightIn);
      if (!inputs) continue;
      const result = calculateFn(productConfig, inputs);
      const cents = result && Number.isFinite(result.totalPriceCents) ? Number(result.totalPriceCents) : 0;
      if (!(cents > 0)) continue;
      const index = i + 1;
      const properties = cartProperties(stair, rampHeightIn);
      if (!properties) continue;
      lines.push({
        source: "stair_ramp",
        variantId: vid,
        qty: 1,
        index: index,
        cfgKey: stairCfgKey(index),
        lengthIn: inputs.width,
        priceCents: cents,
        properties: properties,
      });
    }
    return lines;
  }

  return {
    DEFAULT_STAIR_RAMP_VARIANT_ID: DEFAULT_STAIR_RAMP_VARIANT_ID,
    DEFAULT_STAIR_RAMP_HANDLE: "verre-trempe-pour-descente-d-escalier",
    stairRampInputs: stairRampInputs,
    estimateCents: estimateCents,
    stairCfgKey: stairCfgKey,
    cartProperties: cartProperties,
    pricedLines: pricedLines,
  };
});
